var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import CloseSvg from "assets/svg/close.svg";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactModal from "react-modal";
import { Box, Flex } from "rebass";
import { svgStyle } from "src/styles/helpers";
import { theme } from "src/styles/theme";
import styled from "styled-components";
var CloseIcon = styled(CloseSvg)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  width: 1.2rem;\n  height: 1.2rem;\n"], ["\n  ", ";\n  width: 1.2rem;\n  height: 1.2rem;\n"])), svgStyle);
var modalStyles = {
    overlay: {
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(80,80,80,0.56)",
    },
    content: {
        position: "static",
        overflow: "initial",
        width: "100%",
        maxWidth: "70rem",
        padding: "0",
        border: "none",
        backgroundColor: "transparent",
        inset: "initial",
    },
};
var ModalInner = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  max-width: 65rem;\n  border-radius: 0.8rem;\n  background-color: #ffffff;\n"], ["\n  position: relative;\n  width: 100%;\n  max-width: 65rem;\n  border-radius: 0.8rem;\n  background-color: #ffffff;\n"])));
var CloseButton = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n\n  &:hover {\n    color: ", ";\n  }\n"])), theme.colors.secondary);
function mergeModalStyle(newStyle) {
    if (newStyle === void 0) { newStyle = {}; }
    if ("overlay" in newStyle || "content" in newStyle) {
        return {
            overlay: __assign(__assign({}, modalStyles.overlay), ("overlay" in newStyle && typeof newStyle.overlay === "object"
                ? newStyle.overlay
                : {})),
            content: __assign(__assign({}, modalStyles.content), ("content" in newStyle && typeof newStyle.content === "object"
                ? newStyle.content
                : {})),
        };
    }
    return {
        overlay: modalStyles.overlay,
        content: __assign(__assign({}, modalStyles.content), ("content" in newStyle && typeof newStyle.content === "object"
            ? newStyle.content
            : {})),
    };
}
var Modal = function (_a) {
    var children = _a.children, style = _a.style, containerStyle = _a.containerStyle, _b = _a.shouldCloseOnEsc, shouldCloseOnEsc = _b === void 0 ? true : _b, _c = _a.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _c === void 0 ? true : _c, _d = _a.showCloseButton, showCloseButton = _d === void 0 ? true : _d, onRequestClose = _a.onRequestClose, isOpen = _a.isOpen, contentLabel = _a.contentLabel, others = __rest(_a, ["children", "style", "containerStyle", "shouldCloseOnEsc", "shouldCloseOnOverlayClick", "showCloseButton", "onRequestClose", "isOpen", "contentLabel"]);
    var t = useTranslation().t;
    useEffect(function () {
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
        }
        else {
            document.documentElement.style.overflow = "";
        }
        return function () {
            document.documentElement.style.overflow = "";
        };
    }, [isOpen]);
    var handleKeyDown = function (event) {
        if (event.key === "Escape") {
            onRequestClose();
        }
        if (event.key === "Tab" ||
            event.key === "ArrowLeft" ||
            event.key === "ArrowRight") {
            event.stopPropagation();
        }
    };
    return (React.createElement(ReactModal, __assign({ isOpen: isOpen, shouldCloseOnEsc: shouldCloseOnEsc, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, onRequestClose: onRequestClose, style: mergeModalStyle(style), ariaHideApp: false, preventScroll: false, contentLabel: contentLabel || "Modal" }, others),
        React.createElement(Box, { p: [1, 2, 2], style: __assign({ overflow: "visible" }, containerStyle), onKeyDown: handleKeyDown },
            React.createElement(ModalInner, null,
                showCloseButton && (React.createElement(CloseButton, { as: "button", type: "button", alignItems: "center", justifyContent: "center", onClick: onRequestClose, "aria-label": t("close") },
                    React.createElement(CloseIcon, null))),
                children))));
};
export default Modal;
var templateObject_1, templateObject_2, templateObject_3;
